export default "__VITE_ASSET__DzGEaW_T__"